import React from 'react';
import PropTypes from 'prop-types';
import Icon from "../icon/icon";
export var CLASSNAME = 'Icons-down-direction-arrow';
export var ID = 'icon-down-direction-arrow';
/* eslint-disable max-len */

export var SVGDownDirectionArrow = function SVGDownDirectionArrow() {
  return React.createElement("symbol", {
    id: ID,
    viewBox: "0 0 16 16"
  }, React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M7.73028315,11.8725004 C7.79459287,11.9588866 7.90305551,12.0020797 7.98848184,12.0020797 C8.09694449,12.0020797 8.20444729,11.9588866 8.268757,11.8725004 L13.8704207,6.27179651 C13.9568069,6.18541033 14,6.09902416 14,5.99152136 C14,5.90513518 13.9568069,5.79763238 13.8704207,5.7112462 L13.2676372,5.12957927 C13.2023676,5.04319309 13.0948648,5 13.0084786,5 C12.9009758,5 12.793473,5.04319309 12.7291633,5.12957927 L7.98848184,9.84818429 L3.27083667,5.12957927 C3.18445049,5.04319309 3.09806431,5 2.99056151,5 C2.88305871,5 2.79667253,5.04319309 2.71028635,5.12957927 L2.12861942,5.7112462 C2.04223324,5.79763238 2,5.90513518 2,5.99152136 C2,6.09902416 2.04223324,6.18541033 2.12861942,6.27179651 L7.73028315,11.8725004 Z"
  })));
};
/* eslint-disable max-len */

var DownDirectionArrow = function DownDirectionArrow(props) {
  return React.createElement(Icon, {
    id: ID,
    className: props.className ? "".concat(props.className, " ").concat(CLASSNAME) : CLASSNAME,
    onClick: props.onClick,
    svg: SVGDownDirectionArrow
  });
};

DownDirectionArrow.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};
export default DownDirectionArrow;